export default __webpack_public_path__ + "static/media/edit-pencil.c36240dd.svg";